import { forwardRef, type ReactElement } from 'react'
import { IconBase, type IconProps, type IconWeight } from '@phosphor-icons/react'

/*
 * The scan icon everywhere in Aliens OS: a barcode in a viewfinder's four rounded corners (owner, 2026-10-31: «ايقونه
 * ال سكان … شكلها وحش ومش بروفيشنال … غيرلي شكل ايقونه الاسكان ف اي حته»). Phosphor's own Scan is an empty frame with a
 * line through it. Drawn on Phosphor's 256 grid so it takes the same size, weight and colour props as every other icon.
 */
const corners = 'M80,40H60A20,20,0,0,0,40,60V80M176,40h20a20,20,0,0,1,20,20V80M80,216H60a20,20,0,0,1-20-20V176M176,216h20a20,20,0,0,0,20-20V176'
const bars = (w: number) => (
  <g strokeLinecap="round" strokeWidth={w}>
    <line x1="84" y1="96" x2="84" y2="160" />
    <line x1="108" y1="96" x2="108" y2="160" />
    <line x1="128" y1="96" x2="128" y2="160" />
    <line x1="152" y1="96" x2="152" y2="160" />
    <line x1="172" y1="96" x2="172" y2="160" />
  </g>
)
const draw = (frame: number, bar: number, extra?: ReactElement) => (
  <>
    {extra}
    <path d={corners} fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={frame} />
    <g stroke="currentColor">{bars(bar)}</g>
  </>
)
const weights = new Map<IconWeight, ReactElement>([
  ['thin', draw(8, 8)],
  ['light', draw(12, 12)],
  ['regular', draw(16, 16)],
  ['bold', draw(24, 22)],
  ['fill', draw(16, 20, <rect x="40" y="40" width="176" height="176" rx="24" fill="currentColor" opacity="0.14" />)],
  ['duotone', draw(16, 16, <rect x="64" y="80" width="128" height="96" rx="10" fill="currentColor" opacity="0.2" />)],
])

export const ScanBarcode = forwardRef<SVGSVGElement, IconProps>((props, ref) => <IconBase ref={ref} {...props} weights={weights} />)
ScanBarcode.displayName = 'ScanBarcode'
